module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_9016.827bf356.png";